export default "__VITE_ASSET__BWBiKQI$__"